import { render, staticRenderFns } from "./ComplianceTable.vue?vue&type=template&id=1d1cd3d0"
import script from "./ComplianceTable.vue?vue&type=script&lang=js"
export * from "./ComplianceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports